import './CmsBanner.css';
import { CmsMeta } from '../cmsMeta';

type CmsBannerParams = {
	img: string;
};

export const CmsBanner = ({ img }: CmsBannerParams): JSX.Element => {
	return (
		<div className="banner">
			<img src={img} alt="banner" />
		</div>
	);
};

export const cmsMeta: CmsMeta = {
	description:
		'One picture across the full width of the content, with no text or link. For a picture that should lead somewhere, or that needs a separate mobile crop, use CmsImageHeader.',
	example: [
		'CmsBanner',
		{
			img: 'https://cdn.ondio.com/assets/141f1768a23848c4a6688499d813148e.jpg',
		},
	],
};
